export default "__VITE_ASSET__C9WH75_2__"